// Shard 5 — page-local dictionary entries for:
//   src/pages/ServiceMonitoring.jsx
//   src/pages/MobilityIntelligence.jsx
//   src/pages/HealthIntelligence.jsx
// Zone/place names already covered centrally in dictionary.js
// (COMPONENT_STRINGS) are not repeated here unless the exact string differs.
const shard5 = {
  // ── ServiceMonitoring: headings / KPIs ──────────────────────────
  "Service Stress Intelligence": "सेवा ताण बुद्धिमत्ता",
  "360° NMC · water · toilets · shelters · food zones · medical camps · parking · waste · power · water quality · restocking queue · predictive load · FSSAI food safety · historical benchmarks":
    "360° एनएमसी · पाणी · शौचालये · निवारे · अन्न क्षेत्रे · वैद्यकीय शिबिरे · वाहनतळ · कचरा · वीज · पाणी गुणवत्ता · पुनर्भरण रांग · अंदाजित भार · एफएसएसएआय अन्न सुरक्षा · ऐतिहासिक तुलना",
  "Critical Services": "गंभीर सेवा",
  "High Stress": "उच्च ताण",
  "Total Facilities": "एकूण सुविधा",
  "Active Alerts": "सक्रिय अलर्ट्स",
  "Restocking Pending": "पुनर्भरण प्रलंबित",
  "Avg Platform Load": "सरासरी प्लॅटफॉर्म भार",
  "Food Safety Clear": "अन्न सुरक्षा मंजूर",
  "Power Coverage": "वीज कव्हरेज",

  // Split so facility/critical/high-stress counts compute live from
  // serviceStress/RESTOCKING_QUEUE instead of being baked into the sentence
  // (was hardcoded 7,642 / 3 / 4 — didn't match the underlying arrays).
  "NMC SERVICE COMMAND — 14:33 IST —": "एनएमसी सेवा कमांड — 14:33 आयएसटी —",
  "FACILITIES MONITORED": "सुविधांचे निरीक्षण",
  "Nashik Municipal Corporation — Service Stress Intelligence": "नाशिक महानगरपालिका — सेवा ताण बुद्धिमत्ता",
  "critical ·": "गंभीर ·",
  "high-stress · AI predicts shelter peak at 16:00 (96%) · 6 restocking orders active · water quality all-pass except Nashik Road (watch)":
    "उच्च-ताण · एआयचा अंदाज: निवारा भार 16:00 वाजता शिखरावर (96%) · 6 पुनर्भरण आदेश सक्रिय · नाशिक रोड वगळता पाणी गुणवत्ता सर्वत्र उत्तीर्ण (निरीक्षणाधीन)",

  "Shelters": "निवारे",
  "Toilets": "शौचालये",
  "Food": "अन्न",
  "Water": "पाणी",
  "Shelter Load": "निवारा भार",
  "Toilet Usage": "शौचालय वापर",
  "Food Zone": "अन्न क्षेत्र",
  "Water Station": "जल केंद्र",

  "Water Stations": "पाणी केंद्रे",
  "Parking Lots": "वाहनतळ",
  "Medical Camps": "वैद्यकीय शिबिरे",
  "Food Zones": "अन्न क्षेत्रे",
  "Bus Bays": "बस बे",
  "Waste Points": "कचरा संकलन केंद्रे",
  "MODERATE": "मध्यम",
  "NORMAL": "सामान्य",

  "5,800 units": "5,800 युनिट्स",
  "960 stations": "960 केंद्रे",
  "380 camps": "380 शिबिरे",
  "52 zones": "52 झोन",
  "210 camps": "210 शिबिरे",
  "720 stalls": "720 स्टॉल्स",
  "260 bays": "260 बे",
  "1,400 bins": "1,400 कचराकुंड्या",

  "Overload warning": "जास्त भार इशारा",
  "Current load": "सद्य भार",
  "Capacity": "क्षमता",
  "Forecast 16:00": "अंदाज 16:00",
  "Total units": "एकूण युनिट्स",

  "Service Stress Trend — Today": "सेवा ताण कल — आज",
  "Load % across all service categories — hourly": "सर्व सेवा श्रेणींमधील भार % — तासागणिक",
  "Medical": "वैद्यकीय",
  "Waste": "कचरा",
  "Service Radar — Current Stress Profile": "सेवा रडार — सद्य ताण प्रोफाइल",
  "Current Load": "सद्य भार",
  "Safe Threshold": "सुरक्षित मर्यादा",

  "Predictive Service Load Forecast — 15:00 to 20:00": "अंदाजित सेवा भार पूर्वानुमान — 15:00 ते 20:00",
  "AI-projected service stress for afternoon/evening — Shahi Snan peak expected 16:00":
    "दुपार/संध्याकाळसाठी एआय-अंदाजित सेवा ताण — शाही स्नानाचा शिखर काळ 16:00 वाजता अपेक्षित",
  "AI-generated forecast — human review required before resource allocation decisions":
    "एआय-निर्मित अंदाज — संसाधन वाटप निर्णयांपूर्वी मानवी पुनरावलोकन आवश्यक",
  "Shelters %": "निवारे %",
  "Toilets %": "शौचालये %",
  "Water %": "पाणी %",
  "Medical %": "वैद्यकीय %",
  "Food Zone %": "अन्न क्षेत्र %",

  "Service Load Heatmap — Zone × Category": "सेवा भार हीटमॅप — झोन × श्रेणी",
  "Color coded: red ≥90% · amber ≥75% · blue ≥55% · green <55%": "रंग संकेत: लाल ≥90% · अंबर ≥75% · निळा ≥55% · हिरवा <55%",
  "Zone": "झोन",
  "Shelter": "निवारा",
  "Parking": "वाहनतळ",

  "Shelter Camp Occupancy — Live": "निवारा शिबिर व्याप्ती — थेट",
  "Pilgrim shelter capacity and current occupancy across all 8 camps": "सर्व 8 शिबिरांमधील यात्रेकरू निवारा क्षमता आणि सद्य व्याप्ती",
  "Camp Alpha — Ramkund": "कॅम्प अल्फा — रामकुंड",
  "Camp Beta — Panchvati": "कॅम्प बीटा — पंचवटी",
  "Camp Gamma — Trimbak": "कॅम्प गॅमा — त्र्यंबक",
  "Camp Delta — Nashik Rd": "कॅम्प डेल्टा — नाशिक रोड",
  "Camp Epsilon — Kalaram": "कॅम्प एप्सिलॉन — काळाराम",
  "Camp Zeta — Gangapur": "कॅम्प झीटा — गंगापूर",
  "Overflow OFZ-A — Ring Rd": "ओव्हरफ्लो ओएफझेड-ए — रिंग रोड",
  "Overflow OFZ-B — NH3": "ओव्हरफ्लो ओएफझेड-बी — एनएच3",

  "Restocking & Maintenance Queue": "पुनर्भरण व देखभाल रांग",
  "Active NMC field orders for facility replenishment and repair": "सुविधा पुनर्भरण व दुरुस्तीसाठी सक्रिय एनएमसी क्षेत्रीय आदेश",
  "Cleaning": "स्वच्छता",
  "Refill": "पुनर्भरण",
  "Restock": "साठा भरणे",
  "Collection": "संकलन",
  "Bedding": "अंथरूण साहित्य",
  "Quality": "गुणवत्ता",
  "Team": "पथक",
  "ETA": "अंदाजित वेळ",

  "Drinking Water Quality — Zone Monitoring": "पिण्याचे पाणी गुणवत्ता — झोन निरीक्षण",
  "WHO/BIS parameters: turbidity · chlorine · pH · coliform — tested hourly": "डब्ल्यूएचओ/बीआयएस मापदंड: गढूळपणा · क्लोरीन · पीएच · कोलिफॉर्म — तासागणिक चाचणी",
  "Turbidity": "गढूळपणा",
  "Chlorine": "क्लोरीन",
  "Coliform": "कोलिफॉर्म",
  "ND": "आढळले नाही",
  "Trace": "अंश",
  "Pass": "उत्तीर्ण",
  "Watch": "सतर्कता",

  "Power Supply Status — Critical Facilities": "वीजपुरवठा स्थिती — महत्त्वाच्या सुविधा",
  "Grid · DG · UPS coverage per zone · load percentage": "ग्रिड · डीजी · यूपीएस कव्हरेज प्रति झोन · भार टक्केवारी",
  "Grid": "ग्रिड",
  "Online": "ऑनलाइन",
  "DG": "डीजी",
  "Standby": "सज्ज",
  "Running": "सुरू",
  "crit.": "महत्त्वाचे",

  "Waste Collection — Zone Load": "कचरा संकलन — झोन भार",
  "T collected": " टन संकलित",
  "T pending": " टन प्रलंबित",

  "FSSAI Food Safety Alerts": "एफएसएसएआय अन्न सुरक्षा इशारे",
  "Food stall inspections and violations": "अन्न स्टॉल तपासणी व उल्लंघन",
  "CLEAR": "मंजूर",
  "Temperature violation >65°C": "तापमान उल्लंघन >65°C",
  "Unsafe water source detected": "असुरक्षित जलस्रोत आढळला",
  "Labelling non-compliance": "लेबलिंग अनुपालन नाही",
  "Routine inspection — passed": "नियमित तपासणी — उत्तीर्ण",
  "Fined + warned": "दंड + इशारा",
  "Closed for inspection": "तपासणीसाठी बंद",
  "Advisory issued": "सूचना जारी",
  "Certificate issued": "प्रमाणपत्र जारी",

  "Historical Benchmark": "ऐतिहासिक तुलना",
  "Service stress comparison: 2015 / 2019 / 2027": "सेवा ताण तुलना: 2015 / 2019 / 2027",
  "Kumbh 2015": "कुंभ 2015",
  "Kumbh 2019": "कुंभ 2019",
  "2027 Now": "2027 सद्यस्थिती",

  // ── MobilityIntelligence ─────────────────────────────────────────
  "Transport & Mobility Intelligence": "वाहतूक व गतिशीलता बुद्धिमत्ता",
  "360° railway · MSRTC · shuttle circuits · parking · park-and-ride · pedestrian flow · signal overrides · inbound/outbound balance · delay analysis · night transport · Kumbh 2027 Nashik":
    "360° रेल्वे · एमएसआरटीसी · शटल मार्ग · वाहनतळ · पार्क-अँड-राइड · पादचारी प्रवाह · सिग्नल ओव्हरराइड · आवक/जावक समतोल · विलंब विश्लेषण · रात्रीची वाहतूक · कुंभ 2027 नाशिक",
  "Railway Load": "रेल्वे भार",
  "Bus Load": "बस भार",
  "Shuttle Load": "शटल भार",
  "Parking Load": "वाहनतळ भार",
  "Corridors High": "उच्च भारित मार्ग",
  "Delayed Services": "विलंबित सेवा",
  "Signal Overrides": "सिग्नल ओव्हरराइड",
  "Park+Ride Zones": "पार्क+राइड झोन",

  "TRANSPORT COMMAND — 14:33 IST — ALL MODES ACTIVE": "वाहतूक कमांड — 14:33 आयएसटी — सर्व मार्ग सक्रिय",
  "Maha Kumbh AI Transport & Mobility Command — Simhastha 2027": "महा कुंभ एआय वाहतूक व गतिशीलता कमांड — सिंहस्थ 2027",
  "38 trains · 210 MSRTC buses · 120 shuttles · 52 parking zones · 4 park-and-ride · 4 signal overrides active · AI load forecast: peak 16:00 · Inbound now declining — outbound surge expected 15:30–18:00":
    "38 गाड्या · 210 एमएसआरटीसी बस · 120 शटल · 52 वाहनतळ झोन · 4 पार्क-अँड-राइड · 4 सिग्नल ओव्हरराइड सक्रिय · एआय भार अंदाज: शिखर 16:00 · आवक आता कमी होत आहे — जावक वाढ 15:30–18:00 दरम्यान अपेक्षित",
  "Railway": "रेल्वे",
  "Bus": "बस",
  "Shuttle": "शटल",

  "Pilgrim Mobility Flow — Volume by Mode": "यात्रेकरू गतिशीलता प्रवाह — साधनानुसार संख्या",
  "Hourly passenger volume across railway, bus and shuttle": "रेल्वे, बस व शटलमधील तासागणिक प्रवासी संख्या",

  "Traffic Corridors": "वाहतूक मार्ग",
  "Key route saturation & AI prediction": "मुख्य मार्ग संपृक्तता व एआय अंदाज",
  "Mumbai-Nashik NH3": "मुंबई-नाशिक एनएच3",
  "Nashik-Trimbak Road": "नाशिक-त्र्यंबक रस्ता",
  "Godavari Bridge": "गोदावरी पूल",
  "Panchvati Road": "पंचवटी रस्ता",
  "Gangapur Road": "गंगापूर रस्ता",
  "Gadkari Chowk Junction": "गडकरी चौक जंक्शन",
  "Heavy": "जड",
  "91% at 13:00": "91% 13:00 वाजता",
  "78% at 14:00": "78% 14:00 वाजता",
  "94% at 12:30": "94% 12:30 वाजता",
  "65% at 14:00": "65% 14:00 वाजता",
  "48% at 15:00": "48% 15:00 वाजता",
  "85% at 13:30": "85% 13:30 वाजता",

  "Inbound vs Outbound Balance": "आवक विरुद्ध जावक समतोल",
  "Pilgrims arriving vs departing across all modes — hourly": "सर्व साधनांमधील येणारे विरुद्ध जाणारे यात्रेकरू — तासागणिक",
  "Inbound": "आवक",
  "Outbound": "जावक",
  "Pilgrims In": "आगमन यात्रेकरू",
  "Outbound Peak": "जावक शिखर",
  "Net Present": "निव्वळ उपस्थित",

  "Transport Delay Cause Analysis": "वाहतूक विलंब कारण विश्लेषण",
  "Root cause of delays across all transport modes — today": "सर्व वाहतूक साधनांमधील विलंबाचे मूळ कारण — आज",
  "Crowd overflow on road": "रस्त्यावर गर्दीचा ओघ",
  "Vehicle breakdown": "वाहन बिघाड",
  "Ambulance priority": "रुग्णवाहिका प्राधान्य",
  "VIP/Protocol movement": "व्हीआयपी/प्रोटोकॉल हालचाल",
  "Weather / road surface": "हवामान / रस्ता पृष्ठभाग",
  "Total Delays": "एकूण विलंब",
  "Avg Delay": "सरासरी विलंब",
  "On-time rate": "वेळेवर दर",

  "Live Fleet & Infrastructure Board": "थेट ताफा व पायाभूत सुविधा फलक",
  "Bus Dispatch": "बस पाठवणी",
  "Shuttle Circuits": "शटल मार्ग",
  "Pedestrian Flows": "पादचारी प्रवाह",
  "Express": "एक्सप्रेस",
  "Circular": "वर्तुळाकार",
  "Intercity": "आंतरशहर",
  "load": "भार",
  "Nashik Rd → Ramkund": "नाशिक रोड → रामकुंड",
  "Panchvati → Ramkund loop": "पंचवटी → रामकुंड फेरी",
  "Nashik Rd → Trimbakeshwar": "नाशिक रोड → त्र्यंबकेश्वर",
  "Gadkari → Panchvati": "गडकरी → पंचवटी",
  "Nashik Rd → Gangapur": "नाशिक रोड → गंगापूर",
  "Panchvati → Kalaram loop": "पंचवटी → काळाराम फेरी",
  "Nashik → Igatpuri Park+Ride": "नाशिक → इगतपुरी पार्क+राइड",
  "Mumbai CST → Nashik (IC)": "मुंबई सीएसटी → नाशिक (आयसी)",
  "Bay 1": "बे 1",
  "Bay 2": "बे 2",
  "Bay 3": "बे 3",
  "Bay 4": "बे 4",
  "Bay 5": "बे 5",
  "Bay 7": "बे 7",
  "Bay 9": "बे 9",
  "Bay 11": "बे 11",

  "Every": "दर",
  "vehicles": "वाहने",
  "Avg": "सरासरी",
  "passengers today": "आजचे प्रवासी",
  "Total Vehicles": "एकूण वाहने",
  "Passengers": "प्रवासी",
  "Delayed": "विलंबित",
  "Nashik Rd ↔ Ramkund": "नाशिक रोड ↔ रामकुंड",
  "Panchvati ↔ Kalaram loop": "पंचवटी ↔ काळाराम फेरी",
  "Nashik Rd ↔ Trimbakeshwar": "नाशिक रोड ↔ त्र्यंबकेश्वर",
  "Gadkari ↔ Ramkund": "गडकरी ↔ रामकुंड",
  "Gangapur ↔ Panchvati": "गंगापूर ↔ पंचवटी",

  "ACTIVE": "सक्रिय",
  "Godavari Bridge North": "गोदावरी पूल उत्तर",
  "Gadkari Chowk": "गडकरी चौक",
  "Nashik Road — NH3": "नाशिक रोड — एनएच3",
  "Trimbak Road Junction": "त्र्यंबक रोड जंक्शन",
  "Panchvati Bridge South": "पंचवटी पूल दक्षिण",
  "Ambulance corridor — AMB-07": "रुग्णवाहिका मार्गिका — एएमबी-07",
  "Crowd crossing — peak flow": "गर्दी ओलांडणे — शिखर प्रवाह",
  "MSRTC fleet dispatch": "एमएसआरटीसी ताफा पाठवणी",
  "Pedestrian surge": "पादचारी वाढ",
  "Green extended +90s": "हिरवा वाढवला +90 से",
  "All red 45s cycle": "सर्व लाल 45 से चक्र",
  "Bus priority phase": "बस प्राधान्य टप्पा",
  "Green extended +60s": "हिरवा वाढवला +60 से",

  "Godavari Bridge walkway": "गोदावरी पूल पदपथ",
  "Ramkund Ghat approach": "रामकुंड घाट प्रवेशमार्ग",
  "Panchvati Steps S-4 to S-8": "पंचवटी पायऱ्या एस-4 ते एस-8",
  "Trimbakeshwar Main Road": "त्र्यंबकेश्वर मुख्य रस्ता",
  "Nashik Rd Station exit": "नाशिक रोड स्थानक बाहेर पडण्याचा मार्ग",
  "Barrier deployed": "अडथळा तैनात",
  "PA diversion": "पीए वळवणी",
  "Monitoring": "निरीक्षणाधीन",
  "Action": "कृती",
  "Density": "घनता",
  "Flow/hr": "प्रवाह/तास",
  "Used": "वापरलेले",

  "Total Spaces": "एकूण जागा",
  "Occupied": "व्यापलेले",
  "EV Bays": "ईव्ही बे",
  "P1·Nashik Road Stn": "पी1·नाशिक रोड स्थानक",
  "P2·Panchvati": "पी2·पंचवटी",
  "P3·Gadkari Chowk": "पी3·गडकरी चौक",
  "P4·Trimbak Road": "पी4·त्र्यंबक रस्ता",
  "P5·Gangapur Camp": "पी5·गंगापूर कॅम्प",

  "Train Schedule — Nashik Road Station": "रेल्वे वेळापत्रक — नाशिक रोड स्थानक",
  "Arrivals, platform, load · Shahi Snan special trains included": "आगमन, प्लॅटफॉर्म, भार · शाही स्नान विशेष गाड्यांसह",
  "From": "येथून",
  "Platform": "प्लॅटफॉर्म",
  "Mumbai CST": "मुंबई सीएसटी",
  "Secunderabad": "सिकंदराबाद",
  "Pune": "पुणे",
  "Mumbai": "मुंबई",
  "Hyderabad": "हैदराबाद",
  "On Time": "वेळेवर",

  "Park & Ride Zones — Live Utilisation": "पार्क अँड राइड झोन — थेट वापर",
  "4 park-and-ride hubs with dedicated shuttle links to all Kumbh zones": "सर्व कुंभ झोनसाठी समर्पित शटल जोडणी असलेले 4 पार्क-अँड-राइड केंद्र",
  "Nashik Road PR": "नाशिक रोड पीआर",
  "Deolali Camp PR": "देवळाली कॅम्प पीआर",
  "Satpur MIDC PR": "सातपूर एमआयडीसी पीआर",
  "NH3 Igatpuri PR": "एनएच3 इगतपुरी पीआर",
  "Ramkund / Panchvati": "रामकुंड / पंचवटी",
  "Kalaram / Panchvati": "काळाराम / पंचवटी",
  "All zones via relay": "रिले मार्गे सर्व झोन",

  "Transport Load Forecast — 4-Hour Window": "वाहतूक भार अंदाज — 4-तास विंडो",
  "Predicted load % for railway, bus, shuttle, parking (AI model)": "रेल्वे, बस, शटल, वाहनतळसाठी अंदाजित भार % (एआय मॉडेल)",
  "AI forecast — peak load 16:00 on all modes": "एआय अंदाज — सर्व साधनांवर शिखर भार 16:00 वाजता",
  "Railway %": "रेल्वे %",
  "Bus %": "बस %",
  "Shuttle %": "शटल %",
  "Parking %": "वाहनतळ %",

  "Night Transport Plan — 22:00 to 06:00": "रात्रीची वाहतूक योजना — 22:00 ते 06:00",
  "Post-event departure services — Kumbh 2027 special night schedule for all pilgrims":
    "कार्यक्रमानंतरच्या प्रस्थान सेवा — सर्व यात्रेकरूंसाठी कुंभ 2027 विशेष रात्रीचे वेळापत्रक",
  "Last MSRTC to Mumbai": "मुंबईसाठी शेवटची एमएसआरटीसी",
  "Night shuttle — Ramkund": "रात्रीची शटल — रामकुंड",
  "Emergency auto fleet": "आपत्कालीन रिक्षा ताफा",
  "Train — Tapovan 12533": "गाडी — तपोवन 12533",
  "Train — Panchavati 12102": "गाडी — पंचवटी 12102",
  "Confirmed": "पुष्टी झाली",
  "Reserved": "राखीव",
  "Departs": "प्रस्थान",
  "All zones": "सर्व झोन",

  // ── HealthIntelligence ───────────────────────────────────────────
  "Health & Epidemic Risk Intelligence": "आरोग्य व साथरोग जोखीम बुद्धिमत्ता",
  "360° heatstroke & dehydration analytics · epidemic cluster detection · medical camp load · hospital pipeline · ORS network · supply stock · environmental conditions · vulnerable pilgrim watch · AI case forecasting · Kumbh 2027 Nashik":
    "360° उष्माघात व निर्जलीकरण विश्लेषण · साथरोग गुच्छ शोध · वैद्यकीय शिबिर भार · रुग्णालय पाइपलाइन · ओआरएस नेटवर्क · साठा स्टॉक · पर्यावरणीय स्थिती · असुरक्षित यात्रेकरू निरीक्षण · एआय प्रकरण अंदाज · कुंभ 2027 नाशिक",
  "Heatstroke": "उष्माघात",
  "Dehydration": "निर्जलीकरण",
  "Minor Injuries": "किरकोळ जखमा",
  "Serious Cases": "गंभीर प्रकरणे",
  "Hospital Ref.": "रुग्णालय संदर्भ",
  "Ambulance Active": "रुग्णवाहिका सक्रिय",
  "Camps Overloaded": "अतिभारित शिबिरे",
  "Epidemic Watch": "साथरोग निरीक्षण",
  "2 Active": "2 सक्रिय",

  "HEALTH EOC — CMO NASHIK — 14:33 IST — HEAT INDEX 52°C RAMKUND": "आरोग्य ईओसी — सीएमओ नाशिक — 14:33 आयएसटी — उष्णता निर्देशांक 52°C रामकुंड",
  "Maha Kumbh AI Health & Epidemic Command — Simhastha 2027": "महा कुंभ एआय आरोग्य व साथरोग कमांड — सिंहस्थ 2027",
  "169 total medical cases · 9 serious · 4 hospital referrals · 5 ambulances active · Camp Alpha at 124% capacity · ORS distributed to 44,000 pilgrims · AI heatstroke forecast: peak at 16:00 — 54 cases projected (P50)":
    "169 एकूण वैद्यकीय प्रकरणे · 9 गंभीर · 4 रुग्णालय संदर्भ · 5 रुग्णवाहिका सक्रिय · कॅम्प अल्फा 124% क्षमतेवर · 44,000 यात्रेकरूंना ओआरएस वितरित · एआय उष्माघात अंदाज: शिखर 16:00 वाजता — 54 प्रकरणे अंदाजित (P50)",
  "Heat Index": "उष्णता निर्देशांक",
  "Air Quality": "हवा गुणवत्ता",
  "Amb. Active": "रुग्णवाहिका सक्रिय",
  "ORS Distrib.": "ओआरएस वितरण",

  "Alpha — Ramkund": "अल्फा — रामकुंड",
  "Beta — Panchvati": "बीटा — पंचवटी",
  "Gamma — Trimbak": "गॅमा — त्र्यंबक",
  "Delta — Nashik Rd": "डेल्टा — नाशिक रोड",

  "Medical Case Trend — Today (All Types)": "वैद्यकीय प्रकरण कल — आज (सर्व प्रकार)",
  "Hourly heatstroke · dehydration · injury · serious · referrals": "तासागणिक उष्माघात · निर्जलीकरण · जखम · गंभीर · संदर्भ",
  "Minor Injury": "किरकोळ दुखापत",
  "Serious": "गंभीर",
  "Referral": "संदर्भ",

  "AI Heatstroke Forecast — 12:00 to 18:00": "एआय उष्माघात अंदाज — 12:00 ते 18:00",
  "P25 / P50 / P75 projection bands · peak at 16:00": "P25 / P50 / P75 अंदाज पट्टे · शिखर 16:00 वाजता",
  "AI forecast — human CMO review required before resource allocation": "एआय अंदाज — संसाधन वाटपापूर्वी मानवी सीएमओ पुनरावलोकन आवश्यक",
  "P75 (worst)": "P75 (सर्वात वाईट)",
  "P50 (expected)": "P50 (अपेक्षित)",
  "P25 (best)": "P25 (सर्वोत्तम)",

  "Environmental Health Conditions — Zone by Zone": "पर्यावरणीय आरोग्य स्थिती — झोननिहाय",
  "Temperature · heat index · humidity · UV index · AQI · misting status — updated every 15 min":
    "तापमान · उष्णता निर्देशांक · आर्द्रता · अतिनील निर्देशांक · एक्यूआय · धुके फवारणी स्थिती — दर 15 मिनिटांनी अद्ययावत",
  "Temp °C": "तापमान °C",
  "Humidity": "आर्द्रता",
  "UV Index": "अतिनील निर्देशांक",
  "Shade Cover": "छाया आच्छादन",
  "Misting": "धुके फवारणी",
  "Off": "बंद",
  "Extreme": "अतिटोकाचे",
  "Very High": "अतिउच्च",

  "Epidemic Surveillance & Disease Cluster Board": "साथरोग सर्वेक्षण व रोग गुच्छ फलक",
  "Dehydration Surge": "निर्जलीकरण वाढ",
  "Gastroenteritis": "जठरांत्रशोथ",
  "Respiratory Cluster": "श्वसन गुच्छ",
  "Heat Exhaustion": "उष्णता थकवा",
  "Eye Infection Watch": "डोळा संसर्ग निरीक्षण",
  "Panchvati Entry": "पंचवटी प्रवेशद्वार",
  "Gangapur FZ": "गंगापूर एफझेड",
  "Trimbakeshwar A": "त्र्यंबकेश्वर ए",
  "Multiple": "अनेक",
  "Cluster": "गुच्छ",
  "Surge": "वाढ",
  "cases": "प्रकरणे",
  "rising": "वाढते",
  "stable": "स्थिर",
  "falling": "घटते",
  "Medical team + cooling station deployed": "वैद्यकीय पथक + शीतकरण केंद्र तैनात",
  "ORS distribution — 28 active points": "ओआरएस वितरण — 28 सक्रिय केंद्रे",
  "FSSAI inspection ordered — stall FZ-06": "एफएसएसएआय तपासणी आदेश — स्टॉल एफझेड-06",
  "Monitoring — no action required": "निरीक्षण — कोणतीही कृती आवश्यक नाही",
  "Rest zone + electrolytes active at Bay area": "बे क्षेत्रात विश्रांती क्षेत्र + इलेक्ट्रोलाइट्स सक्रिय",
  "Monitoring — eye drop kits at all camps": "निरीक्षण — सर्व शिबिरांमध्ये डोळ्याचे थेंब संच",
  "Response SOP": "प्रतिसाद एसओपी",
  "Isolate critical cases": "गंभीर प्रकरणे विलग करा",
  "Activate cooling zone": "शीतकरण क्षेत्र सक्रिय करा",
  "Dispatch AMB-03": "एएमबी-03 पाठवा",
  "Alert Civil Hospital ICU": "सिव्हिल हॉस्पिटल आयसीयूला सतर्क करा",
  "Monitor temperature + density every 15 min": "दर 15 मिनिटांनी तापमान + घनता तपासा",
  "Expand ORS points by 6": "ओआरएस केंद्रे 6 ने वाढवा",
  "Increase water tanker frequency": "पाणी टँकर फेऱ्या वाढवा",
  "Deploy shade tents in Entry zone": "प्रवेश क्षेत्रात छाया तंबू तैनात करा",
  "PA broadcast every 30 min": "दर 30 मिनिटांनी पीए घोषणा",
  "Close stall FZ-06 for inspection": "तपासणीसाठी स्टॉल एफझेड-06 बंद करा",
  "Check adjacent food zones": "लगतच्या अन्न क्षेत्रांची तपासणी करा",
  "Sample food for lab test": "प्रयोगशाळा चाचणीसाठी अन्न नमुना घ्या",
  "Alert nearby camp nurses": "जवळील शिबिर परिचारिकांना सतर्क करा",
  "Continue hourly surveillance": "तासागणिक सर्वेक्षण सुरू ठेवा",
  "Check for environmental trigger": "पर्यावरणीय कारण तपासा",
  "Report to state health if >10 cases": ">10 प्रकरणे झाल्यास राज्य आरोग्य विभागाला कळवा",
  "Deploy electrolyte point at Bay 2": "बे 2 वर इलेक्ट्रोलाइट केंद्र तैनात करा",
  "Shade tent at station exit": "स्थानक बाहेर पडण्याच्या मार्गावर छाया तंबू",
  "Volunteer health watch every 20 min": "दर 20 मिनिटांनी स्वयंसेवक आरोग्य तपासणी",
  "Distribute eye drop kits": "डोळ्याचे थेंब संच वाटप करा",
  "Public hygiene advisory via PA": "पीएमार्फत सार्वजनिक स्वच्छता सूचना",
  "Monitor for cluster formation": "गुच्छ निर्मितीसाठी निरीक्षण करा",

  "Medical Camp Detail Board — Click to expand": "वैद्यकीय शिबिर तपशील फलक — विस्तारासाठी क्लिक करा",
  "OVER CAPACITY": "क्षमतेपेक्षा जास्त",
  "NEAR FULL": "जवळपास पूर्ण",
  "OK": "ठीक",
  "beds": "खाटा",
  "cases today": "आजची प्रकरणे",
  "Doctors": "डॉक्टर",
  "Paramedics": "पॅरामेडिक्स",
  "Referrals": "संदर्भ",
  "Case Breakdown": "प्रकरण विभाजन",
  "Chronic/Other": "दीर्घकालीन/इतर",
  "Supply Status": "साठा स्थिती",
  "ORS Packets": "ओआरएस पाकिटे",
  "pkts": "पाकिटे",
  "IV Fluids": "आयव्ही द्रव",
  "bags": "पिशव्या",
  "O₂ Cylinders": "ओ₂ सिलिंडर",
  "cylnd.": "सिलिंडर",
  "Stretchers": "स्ट्रेचर",
  "Paracetamol": "पॅरासिटामॉल",
  "Logistics": "रसद",
  "Last inspection": "शेवटची तपासणी",
  "on duty": "कर्तव्यावर",
  "Nashik Road": "नाशिक रोड",

  "Zone-Level Health Risk Matrix": "झोन-स्तरीय आरोग्य जोखीम मॅट्रिक्स",
  "Heat · dehydration · epidemic risk by zone — grouped bar": "झोननिहाय उष्णता · निर्जलीकरण · साथरोग जोखीम — गटबद्ध बार",
  "Heat Risk %": "उष्णता जोखीम %",
  "Dehydration %": "निर्जलीकरण %",
  "Injury Risk %": "जखम जोखीम %",
  "Epidemic %": "साथरोग %",

  "Crowd Density × Health Case Correlation": "गर्दी घनता × आरोग्य प्रकरण सहसंबंध",
  "Zone crowd density (from Crowd Intelligence) against heatstroke + dehydration case load — higher density correlates with higher case load":
    "झोन गर्दी घनता (गर्दी बुद्धिमत्तेवरून) वि. उष्माघात + निर्जलीकरण प्रकरण भार — अधिक घनता म्हणजे अधिक प्रकरण भार",
  "Crowd Density": "गर्दी घनता",
  "Heat Cases": "उष्णता प्रकरणे",
  "Dehydration Cases": "निर्जलीकरण प्रकरणे",
  "Correlated Risk": "सहसंबंधित जोखीम",
  "Zone density figures are shared with the Crowd Intelligence page — a rising trend there is a leading indicator for medical camp load here, before case counts themselves rise.":
    "झोन घनतेचे आकडे गर्दी बुद्धिमत्ता पानाशी सामायिक आहेत — तेथील वाढता कल हा प्रकरण संख्या वाढण्यापूर्वीच वैद्यकीय शिबिर भाराचा पूर्वसंकेत आहे.",

  "Medical Case Composition — Today": "वैद्यकीय प्रकरण रचना — आज",
  "Total cases": "एकूण प्रकरणे",

  "Hospital Referral Pipeline": "रुग्णालय संदर्भ पाइपलाइन",
  "Capacity and ICU availability at receiving hospitals — live": "प्राप्तकर्ता रुग्णालयांमधील क्षमता व आयसीयू उपलब्धता — थेट",
  "Civil Hospital Nashik": "सिव्हिल हॉस्पिटल नाशिक",
  "Wockhardt Hospital": "वोखार्ड हॉस्पिटल",
  "Zen Multi Specialty": "झेन मल्टी स्पेशालिटी",
  "GMCH Nashik (Govt.)": "जीएमसीएच नाशिक (शासकीय)",
  "Trimbak PHC": "त्र्यंबक पीएचसी",
  "Accepting": "स्वीकारत आहे",
  "Near Full": "जवळपास पूर्ण",
  "Overflow": "ओव्हरफ्लो",
  "General + Trauma": "सर्वसाधारण + आघात",
  "Cardio + ICU": "हृदयरोग + आयसीयू",
  "General": "सर्वसाधारण",
  "All departments": "सर्व विभाग",
  "Primary care": "प्राथमिक काळजी",
  "Beds": "खाटा",

  "ORS Distribution Network": "ओआरएस वितरण नेटवर्क",
  "Oral rehydration distribution points · packets distributed · stock remaining per zone":
    "तोंडावाटे पुनर्जलीकरण वितरण केंद्रे · वितरित पाकिटे · प्रति झोन शिल्लक साठा",
  "pts": "केंद्रे",
  "distrib.": "वितरित",
  "left": "शिल्लक",
  "ORS Points": "ओआरएस केंद्रे",
  "Distributed": "वितरित",
  "Total Stock": "एकूण साठा",

  "Medical Resources & Deployment": "वैद्यकीय संसाधने व तैनाती",
  "Drug & Supply Stock": "औषध व साठा स्टॉक",
  "Medical Personnel": "वैद्यकीय कर्मचारी",
  "Vulnerable Pilgrim Watch": "असुरक्षित यात्रेकरू निरीक्षण",
  "IV Fluids (Saline)": "आयव्ही द्रव (सलाईन)",
  "Paracetamol 500mg": "पॅरासिटामॉल 500mg",
  "Oral Rehydration Salt": "तोंडावाटे पुनर्जलीकरण मीठ",
  "Antihistamine Tabs": "अँटीहिस्टामाइन गोळ्या",
  "Oxygen Cylinders": "ऑक्सिजन सिलिंडर",
  "Gloves (boxes)": "हातमोजे (खोकी)",
  "ICE Packs": "बर्फ पॅक",
  "Cooling Vests": "शीतकरण जॅकेट",
  "strips": "पट्ट्या",
  "sachets": "पुड्या",
  "cylind.": "सिलिंडर",
  "units": "युनिट्स",
  "boxes": "खोकी",
  "packs": "पॅक",
  "vests": "जॅकेट",
  "used": "वापरले",
  "remaining": "शिल्लक",
  "⚠ Ice Packs (18% remaining) and Cooling Vests (10% remaining) — resupply order placed · ETA 16:30":
    "⚠ बर्फ पॅक (18% शिल्लक) आणि शीतकरण जॅकेट (10% शिल्लक) — पुनर्पुरवठा आदेश दिला · अपेक्षित वेळ 16:30",

  "Nurses": "परिचारिका",
  "Volunteers": "स्वयंसेवक",
  "Total": "एकूण",
  "Per 10K": "प्रति 10 हजार",
  "Total Doctors": "एकूण डॉक्टर",
  "Med Volunteers": "वैद्यकीय स्वयंसेवक",

  "Elderly (60+ yrs)": "वृद्ध (60+ वर्षे)",
  "Children (0–12 yrs)": "मुले (0–12 वर्षे)",
  "Cardiac Patients": "हृदयरोगी",
  "Diabetics": "मधुमेही",
  "Pregnant Women": "गर्भवती महिला",
  "Risk": "जोखीम",
  "Camps only": "फक्त शिबिरे",
  "Priority triage · Cooling vest · IV preference": "प्राधान्य ट्रायेज · शीतकरण जॅकेट · आयव्ही प्राधान्य",
  "Shade mandate · ORS push · Temp monitor": "छाया अनिवार्य · ओआरएस पुरवठा · तापमान निरीक्षण",
  "Pre-identified · Ambulance proximity · ECG ready": "आधीच ओळखलेले · रुग्णवाहिका जवळ · ईसीजी सज्ज",
  "Blood sugar monitoring · Dedicated rest zone": "रक्तशर्करा निरीक्षण · समर्पित विश्रांती क्षेत्र",
  "Dedicated shaded area · Midwife on standby": "समर्पित छायांकित क्षेत्र · सुईण स्टँडबायवर",
  "identified pilgrims": "ओळखलेले यात्रेकरू",

  "Health Zone Risk Summary": "आरोग्य झोन जोखीम सारांश",
  "Full risk matrix per zone with overall status indicator": "एकूण स्थिती निर्देशकासह प्रति झोन संपूर्ण जोखीम मॅट्रिक्स",
  "Heat": "उष्णता",
  "Dehydr.": "निर्जलीकरण",
  "Epidemic": "साथरोग",
  "Injury": "जखम",
  "Overall": "एकूण",

  "Historical Health Benchmark": "ऐतिहासिक आरोग्य तुलना",
  "Simhastha 2027 vs Kumbh 2015 & 2019 — by 11:00 hrs mark": "सिंहस्थ 2027 वि. कुंभ 2015 व 2019 — 11:00 वाजेपर्यंत",
  "Heatstroke Cases": "उष्माघात प्रकरणे",
  "Dehydration Cases": "निर्जलीकरण प्रकरणे",
  "Hospital Referrals": "रुग्णालय संदर्भ",
  "Mortality": "मृत्यू",
  "2027 (11 hrs)": "2027 (11 तास)",
  "✓ 2027 tracking 55% fewer heatstroke cases vs 2015 (same 11hr window) — proactive ORS + shade infrastructure":
    "✓ 2027 मध्ये 2015 च्या तुलनेत (समान 11 तास कालावधीत) 55% कमी उष्माघात प्रकरणे — सक्रिय ओआरएस + छाया पायाभूत सुविधांमुळे",
};

export default shard5;
